module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-2-ce82e13d.png";